<template>
   <login-extra-page :showLeftColumn="false" :boxLogo="false">
    <template v-slot:content>
    <v-layout v-if="hasProfile === null || error != null" align-center justify-center class="mt-6">
      <v-progress-circular v-if="error == null" indeterminate color="primary"/>
      <v-alert dense text :value="error != null" type="error" data-testid="v-alert_a50c9330-5650-4a2e-87ed-5ecf324f0c94">
        {{error}}
      </v-alert>
    </v-layout>
    <r-form-card class="mb-4">
      <template slot="header">
        <img src="static/images/vevox-logo.svg" class="headerimage pa-4"/>
      </template>
      <r-form-header>
        {{ formHeader }}
      </r-form-header>

      <div v-if="hasProfile === false">{{ enterNameHeader }}</div>

      <v-form ref="userform" v-model="profileFormValid" lazy-validation>
        <v-layout v-if="hasProfile === false" row>
          <v-flex data-testid="v-flex_be6bd6ea-1b2f-4152-b2b9-13fa63b5b60b">
            <r-form-text-field v-model="profile.firstName" :rules="nameRules" v-bind:label="$t('first_name')" data-testid="r-form-text-field_db599f57-815b-4472-9541-0000603eb2e8"></r-form-text-field>
          </v-flex>
          <v-flex xs1 data-testid="v-flex_f5d75831-2172-4d70-9e8e-f151fec63344"/>
          <v-flex data-testid="v-flex_2b4da6e4-ce5d-4c01-a26d-5bac3f0a3360">
            <r-form-text-field v-model="profile.lastName" :rules="nameRules" v-bind:label="$t('last_name')" data-testid="r-form-text-field_378d80b5-317d-494c-8b01-91660f1f2e66"></r-form-text-field>
          </v-flex>
        </v-layout>
        <div class="buttondiv">
          <r-form-submit-button :loading="loading" :disabled="loading" v-on:click="requestAccess" data-testid="r-form-submit-button_42210a78-0f14-4fbf-8630-f1a0f87b427f">{{ buttonText }}</r-form-submit-button>
        </div>
      </v-form>
    </r-form-card>
   </template>
 </login-extra-page>
</template>

<script>
import { dashboardUserService } from 'reactor-js-core/dist/services/dashboarduserservice.js'
import { signupService } from 'reactor-js-core/dist/services/signupservice.js'
import { persistentStorage } from 'reactor-js-core/dist/persistentstorage.js'
import { sharedReactorWebsocket as ws} from 'reactor-js-core';
import cookieconsent from '@/js/cookieconsent'
import LoginExtraPage from '@/components/login/LoginExtraPage';

export default {
  name: 'RequestAccess',
  components: {
    LoginExtraPage
  },
  data() {
    return {
      profileFormValid: false,
      error: null,
      profile: {
        firstName: "",
        lastName: ""
      },
      nameRules: [
        name => {
          if (name.length == 0) return this.$t('required');
          return true;
        }
      ],
      tenancy: null,
      hasProfile: null,
      email: null,
      loading: false,
      linkWithExisting: false,
    }
  },
  computed: {
    formHeader() {
      if (this.linkWithExisting) {
        return this.$t("request_access_verify_header");
      }

      if (this.tenancy == null) return "";
      return this.$t("organization_already_has_account", { tenancy_name: this.tenancy.tenancyName, interpolation: { escapeValue: false } });
    },
    buttonText() {
      if (this.linkWithExisting) {
        return this.$t("request_access_verify");
      }

      return this.$t("request_access");
    },
    enterNameHeader() {
      if (this.linkWithExisting) {
        return this.$t("enter_name_and_verify");
      }
      return this.$t("enter_name_and_request");
    }
  },
  methods: {
    requestAccessResponse(response) {
      if (response.accessStatus["@type"] === "AccessStatusGranted") {
        var reactordashboard_tenancy = this.$root.convertToReactorDashboardUrl(this.tenancy);
        persistentStorage.set("loginTenancyUrl", reactordashboard_tenancy);
        var hash_index = window.location.href.indexOf("#");
        var single_login_page_main = window.location.href.substring(0, hash_index);
        if (!(single_login_page_main.endsWith('/') || single_login_page_main.endsWith('/index.html'))) {
          single_login_page_main += '/';
        }
        window.location.href = reactordashboard_tenancy + "#/tokenlogin?login_verification_url=" + encodeURIComponent(single_login_page_main + "#/tokenlogin?login_csrf_token=" + persistentStorage.get("loginCSRFToken")) + cookieconsent.getConsentTransferParameter();
      }
      else if (response.accessStatus["@type"] === "AccessStatusInvitationSent") {
        this.$root.alert(this.$t("added_to_account_verify_email", {tenancy_name: this.tenancy.tenancyName, email:this.email, interpolation: { escapeValue: false }}), () => {
          this.$router.push({
            path: "/"
          });
        });
      }
      else if (response.accessStatus["@type"] === "AccessStatusPendingApproval") {
        this.$root.alert({
          title: this.$t("waiting_approval_title"),
          message: this.$t("waiting_approval", {tenancy_name: this.tenancy.tenancyName, email:this.email, interpolation: { escapeValue: false }})
          }, () => {
          this.$router.push({
            path: "/"
          });
        });
      }
      else if (response.accessStatus["@type"] === "AccessStatusMaxRequestsReached") {
        this.$root.alert(this.$t("maximum_access_requests_reached"), () => {
          this.$router.push({
            path: "/"
          });
        });
      }
      else if (response.accessStatus["@type"] === "AccessStatusUserVerificationPending") {
        this.$root.alert(this.$t("request_access_awaiting_verification", { email: this.email }), () => {
          this.$router.push({
            path: "/"
          });
        });
      }
      else {
        this.$root.alert(this.$t("undefined_error"), () => {
          this.$router.push({
            path: "/"
          });
        });
      }
    },
    requestAccess() {
      if (this.hasProfile) {
        this.loading = true;
        dashboardUserService.requestAcccessForTenancy({loginToken: this.$route.query.id, tenancyId: this.tenancy.tenancyId}).then(this.requestAccessResponse, (failure) => {
          if (failure != null && failure.failure != null && failure.failure.message === "UserLimitReachedException") {
            failure.remove();
            this.error = this.$t('user_limit_reached');
          }
          else {
            this.error = this.$t('undefined_error');
          }
        }).finally(() => {
          this.loading = false;
        });
      }
      else if (this.$refs.userform.validate()) {
        this.loading = true;
        signupService.completeProfileAndRequestAccess({loginToken: this.$route.query.id, tenancyId: this.tenancy.tenancyId, firstName: this.profile.firstName, lastName: this.profile.lastName}).then(this.requestAccessResponse, (failure) => {
          if (failure != null && failure.failure != null && failure.failure.message === "UserLimitReachedException") {
            failure.remove();
            this.error = this.$t('user_limit_reached');
          }
          else {
            this.error = this.$t('undefined_error');
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    let tenancy_id = null;
    if (this.$route.query.tenancy != null) {
      this.tenancy = JSON.parse(this.$route.query.tenancy);
      tenancy_id = this.tenancy.tenancyId;

      if (this.tenancy.regionURL != null) {
        this.$root.connectToRegion(this.tenancy.regionURL);
      }
    }
    dashboardUserService.validateLoginTokenCredentials(this.$route.query.id, tenancy_id).then((validation_response) => {
      if (validation_response.authUserId == null) {
        this.error = this.$t('link_expired');
        return;
      }
      else if (validation_response.otherUserExists === true && validation_response.allowLinkingToExisting !== true) {
        if (validation_response.tenancy != null) this.tenancy = validation_response.tenancy;

        this.$root.alert(this.$t("use_other_credentials"), () => {
          this.$router.push({
            path: "/"
          });
        });
      }
      else {
        this.linkWithExisting = (validation_response.allowLinkingToExisting === true);
        this.hasProfile = validation_response.hasProfile;
        this.email = validation_response.email;
        if (validation_response.tenancy != null) this.tenancy = validation_response.tenancy;
      }
    }, (failure) => {
      this.error = this.$t('undefined_error');
    });
  }
}
</script>

<style scoped>
.headerimage {
  width: 100%;
  max-width: 480px;
}
.buttondiv {
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/user/RequestAccess.vue